import utils from 'components/utilsComponent';
import KurortPriceFilter from 'components/kurort/kurortPriceFilterComponent';
import KurortRoomFilter from 'components/kurort/kurortRoomFilterComponent';
import KurortCheckboxSearch from 'components/kurort/kurortCheckboxSearchComponent';
import KurortInfoPlate from 'components/kurort/kurortInfoPlate';
import KurortDistanceFilter from 'components/kurort/kurortDistanceFilter';
import Hint from 'components/hint';
import Swiper from 'swiper';
import { Navigation, Pagination as SwiperPagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import {checkGA} from 'methods/utils';
import metrikaCollector, {collectGoogleEvent, collectYandexReachGoal} from 'components/metrika';
import {isPercentFilterActive} from 'components/utm-cookies';
import Pagination from 'components/pagination';
import {injectNoFoundBlock} from 'components/no-found-block';

Swiper.use([Navigation, SwiperPagination]);

function checkOnMapSubset() {
    let $button = document.querySelector('.js-mapModalOpen');
    if (!$button || $button.classList.contains('is-opened') || location.pathname.indexOf('/onmap/') === -1) {
        return false;
    }
    $button.classList.add('is-opened');
    $button.dispatchEvent(new Event('click'));
}

/**
 * Получаем все данные пользователя для работы на страницах со статичным контентом
 */
function KurortFilter() {
    injectNoFoundBlock();

    /**
     * Показываем блок нет предложений и выбранные фильтры
     */
    this.showContainerResultFilter = function() {
        document.querySelector('.js-containerResultFilter')?.classList.add('is-active');
        document.querySelector('.js-headerResultFilter')?.classList.add('is-active');
    }.bind(this);

    this.showResultFilter = function() {
        let $noFoundFilterContainer     = document.querySelector('.js-noFoundFilterContainer');
        let $noFoundFilterWrapper       = document.querySelector('.js-noFoundFilterWrapper');
        let $noFoundFilterResetWrapper  = document.querySelector('.js-noFoundResetFilterWrapper');

        if ($noFoundFilterContainer) {
            $noFoundFilterContainer.innerHTML = '';
        }

        if ($noFoundFilterResetWrapper) {
            $noFoundFilterResetWrapper.innerHTML = '';
        }

        // опции
        [this.checkboxTypes, ...this.checkboxOptions, this.checkboxPromo, this.checkboxPriceOptions, this.checkboxStar].forEach(checkbox => {
            checkbox.getCheckedOptions().forEach(item => {
                $noFoundFilterContainer.insertAdjacentHTML('beforeend', `
                    <li class="Kurort-sidebar__selected-item">
                        <div class="Kurort-sidebar__selected-item-title">
                            ${item.title}
                        </div>
                        <button class="Kurort-sidebar__selected-item-reset js-resetFilterItem" type="button" data-id="${item.id}" data-type="${item.type}">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M18.5303 6.53033C18.8232 6.23744 18.8232 5.76256 18.5303 5.46967C18.2374 5.17678 17.7626 5.17678 17.4697 5.46967L12 10.9393L6.53033 5.46967C6.23744 5.17678 5.76256 5.17678 5.46967 5.46967C5.17678 5.76256 5.17678 6.23744 5.46967 6.53033L10.9393 12L5.46967 17.4697C5.17678 17.7626 5.17678 18.2374 5.46967 18.5303C5.76256 18.8232 6.23744 18.8232 6.53033 18.5303L12 13.0607L17.4697 18.5303C17.7626 18.8232 18.2374 18.8232 18.5303 18.5303C18.8232 18.2374 18.8232 17.7626 18.5303 17.4697L13.0607 12L18.5303 6.53033Z"
                                      fill="#6A6D81"/>
                            </svg>
                        </button>
                    </li>
                `);
            });
        });

        this.distanceFilters.filter(component => component.isInit()).forEach(component => {
            const title = `${component.filterTitle}: ${component.getSelectedValueTitle()}`;

            $noFoundFilterContainer.insertAdjacentHTML('beforeend', `
                <li class="Kurort-sidebar__selected-item">
                    <div class="Kurort-sidebar__selected-item-title">
                        ${title}
                    </div>
                    <button class="Kurort-sidebar__selected-item-reset js-resetDistanceFilter" type="button" data-name="${component.name}">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M18.5303 6.53033C18.8232 6.23744 18.8232 5.76256 18.5303 5.46967C18.2374 5.17678 17.7626 5.17678 17.4697 5.46967L12 10.9393L6.53033 5.46967C6.23744 5.17678 5.76256 5.17678 5.46967 5.46967C5.17678 5.76256 5.17678 6.23744 5.46967 6.53033L10.9393 12L5.46967 17.4697C5.17678 17.7626 5.17678 18.2374 5.46967 18.5303C5.76256 18.8232 6.23744 18.8232 6.53033 18.5303L12 13.0607L17.4697 18.5303C17.7626 18.8232 18.2374 18.8232 18.5303 18.5303C18.8232 18.2374 18.8232 17.7626 18.5303 17.4697L13.0607 12L18.5303 6.53033Z"
                                  fill="#6A6D81"/>
                        </svg>
                    </button>
                </li>
            `);
        });

        const values = this.priceSearch.getValues();

        // минималка
        if (this.priceSearch.isFromValueSelected()) {
            $noFoundFilterContainer.insertAdjacentHTML('beforeend', `
                <li class="Kurort-sidebar__selected-item">
                    <div class="Kurort-sidebar__selected-item-title">
                        от ${this.priceSearch.format(values.from)} ${document.body.dataset.currency_short_title}
                    </div>
                    <button class="Kurort-sidebar__selected-item-reset js-resetFilterItem js-resetMinPrice" data-type="price" type="button">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M18.5303 6.53033C18.8232 6.23744 18.8232 5.76256 18.5303 5.46967C18.2374 5.17678 17.7626 5.17678 17.4697 5.46967L12 10.9393L6.53033 5.46967C6.23744 5.17678 5.76256 5.17678 5.46967 5.46967C5.17678 5.76256 5.17678 6.23744 5.46967 6.53033L10.9393 12L5.46967 17.4697C5.17678 17.7626 5.17678 18.2374 5.46967 18.5303C5.76256 18.8232 6.23744 18.8232 6.53033 18.5303L12 13.0607L17.4697 18.5303C17.7626 18.8232 18.2374 18.8232 18.5303 18.5303C18.8232 18.2374 18.8232 17.7626 18.5303 17.4697L13.0607 12L18.5303 6.53033Z"
                                  fill="#6A6D81"/>
                        </svg>
                    </button>
                </li>
            `);
        }

        // максималка
        if (this.priceSearch.isToValueSelected()) {
            $noFoundFilterContainer.insertAdjacentHTML('beforeend', `
                <li class="Kurort-sidebar__selected-item">
                    <div class="Kurort-sidebar__selected-item-title">
                        до ${this.priceSearch.format(values.to)} ${document.body.dataset.currency_short_title}
                    </div>
                    <button class="Kurort-sidebar__selected-item-reset js-resetFilterItem js-resetMaxPrice" data-type="price" type="button">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M18.5303 6.53033C18.8232 6.23744 18.8232 5.76256 18.5303 5.46967C18.2374 5.17678 17.7626 5.17678 17.4697 5.46967L12 10.9393L6.53033 5.46967C6.23744 5.17678 5.76256 5.17678 5.46967 5.46967C5.17678 5.76256 5.17678 6.23744 5.46967 6.53033L10.9393 12L5.46967 17.4697C5.17678 17.7626 5.17678 18.2374 5.46967 18.5303C5.76256 18.8232 6.23744 18.8232 6.53033 18.5303L12 13.0607L17.4697 18.5303C17.7626 18.8232 18.2374 18.8232 18.5303 18.5303C18.8232 18.2374 18.8232 17.7626 18.5303 17.4697L13.0607 12L18.5303 6.53033Z"
                                  fill="#6A6D81"/>
                        </svg>
                    </button>
                </li>
            `);
        }

        // добавляем кнопку сброса фильтров

        // Предполагаем, что переменные $noFoundFilterWrapper и $noFoundFilterContainer уже объявлены и являются элементами DOM
        if ($noFoundFilterContainer && $noFoundFilterWrapper) {
            $noFoundFilterWrapper.style.display = $noFoundFilterContainer.innerHTML.length > 0 ? 'block' : 'none';
        }
    }.bind(this);

    this.serializeArray = function($forms) {
        return [...$forms].reduce((acc, $form) => {
            return acc.concat([...(new FormData($form)).entries()].map(([name, value]) => {
                return { name, value };
            }));
        }, []);
    }.bind(this);

    this.getFormData = function(show_more = false) {
        const data = [];

        data.push(this.serializeArray(document.querySelectorAll('.js-leftKurortFilter')));
        data.push(this.serializeArray(document.querySelectorAll('.js-topKurortFilter')));
        data.push(this.serializeArray(document.querySelectorAll('.js-filterForm')));

        if (show_more) {
            // TODO: удалить, с обычной пагинацией параметр лишний
            // const $elements = [...document.querySelectorAll('.js-hotelItem .js-objectFavorite')];
            // data.push([
            //     {name: 'exclude_hotel_ids', value: $elements.map($element => $element.dataset.id)}
            // ]);
        }

        if (window.kurortMapModal) {
            data.push({
                name: 'filter',
                value: 'map',
            });

            if (window.kurortMapModal.getSearchOnMove()) {
                const bounds = window.kurortMapModal.map.getBounds();
                const [latFrom, lngFrom] = bounds[0];
                const [latTo, lngTo] = bounds[1];

                data.push({
                    name: 'bounds',
                    value: `${lngFrom},${latFrom}-${lngTo},${latTo}`,
                });

                data.push({
                    name: 'zoom',
                    value: window.kurortMapModal.map.getZoom(),
                });
            }
        }

        return data.reduce((acc, arr) => {
            return acc.concat(arr);
        }, []);
    }

    this.init = function() {
        this.initialized = false;
        const $form = document.querySelector('.js-leftKurortFilter');
        const url = new URL(window.location);
        const obj = this;
        let onResetCallback;

        const urlEntries = [...url.searchParams.entries()];
        const getArraySearchParams = (name) => {
            return urlEntries.reduce((acc, [key, value]) => {
                const match = key.match(/^(\w+)\[(\d+)\]$/);

                if (match && match[1] == name) {
                    acc.push(match[2]);
                }

                return acc;
            }, []);
        }

        // нету контента - вырубаем прелоадер и умираем
        if (!$form) {
            document.querySelector('.js-hotelListSkelet')?.classList?.add('is-hidden');
            document.querySelector('.js-leftFilterContainer')?.classList?.add('is-hidden');
            document.querySelector('.Kurort-sidebar')?.classList?.add('is-hidden');
            return;
        }

        const $priceOptionButtons = document.querySelector('.js-priceOptionButtons');
        const $buttonsSlide       = $priceOptionButtons.querySelector('.js-buttonsSlide');
        const $periodButton       = $priceOptionButtons.querySelector('.js-periodButton');
        const $dayButton          = $priceOptionButtons.querySelector('.js-dayButton');
        let $lastButtonSlide      = $dayButton;
        let prevEvent             = null;

        if ($priceOptionButtons) {
            this.priceOptionHint = new Hint($priceOptionButtons, {
                content: 'Укажите даты поездки, что бы узнать цену за период проживания',
                interactive: false,
                canOpen: () => {
                    return $periodButton.classList.contains('is-disabled');
                },
            });
        }

        this.initDatepickerFn = function() {
            // если убрать, то кнопки будут переключаться постоянно
            if (prevEvent === 'init') {
                return;
            }
            prevEvent = 'init';

            $periodButton.classList.remove('is-disabled');

            // пользователь выбрал стоимость за ночь, поэтому не перключаем кнопки!
            if (this.checkboxPriceOptions.getCurrentType() === 'day') return;

            this.switchSlide($dayButton, $periodButton);
        }.bind(this);

        this.noInitDatepickerFn = function() {
            // если убрать, то кнопки будут переключаться постоянно
            if (prevEvent === 'noInit') {
                return;
            }
            prevEvent = 'noInit';

            $periodButton.classList.add('is-disabled');

            this.switchSlide($periodButton, $dayButton);
        }

        /**
         * Триггеры
         */
        function triggers() {
            /**
             * Клик сортировка объектов
             */
            utils.addTrigger('click', '.js-kurortFilterItem', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const sort = this.getAttribute('data-sort');

                document.querySelectorAll('.js-kurortFilterText').forEach($element => {
                    $element.textContent = this.textContent;
                });

                document.querySelectorAll('.js-sortField').forEach($element => {
                    $element.value = sort;
                });

                let $verifiedBlock = document.querySelector('.js-verifiedBlock');
                if ($verifiedBlock) {
                    if (sort !== 1) {
                        $verifiedBlock.style.display = 'block';
                    } else {
                        $verifiedBlock.style.display = 'none';
                    }
                }

                obj.formRecalc();
            });

            /**
             * Клик чекбокс проверенное жилье
             */
            utils.addTrigger('click', '.js-verifiedCheckbox', function(e) {
                e.preventDefault();
                e.stopPropagation();

                this.classList.toggle('is-active');

                const isChecked = this.classList.contains('is-active') ? 1 : 0;
                let $verifiedField = document.querySelector('.js-verifiedField');
                if ($verifiedField) {
                    $verifiedField.value = isChecked;
                }

                obj.formRecalc();
            });

            document.addEventListener('click', event => {
                const targetClosest = (selector) => event.target.closest && event.target.closest(selector);
                /**
                 * Клик очистить фильтры
                 */
                if (targetClosest('.js-kurortClearFilters, .js-clearAllFilter, .js-resetFilterButton')) {
                    if (
                        !this.priceSearch.isInit()
                        && (this.roomSearch && !this.roomSearch.isInit())
                        && !this.checkboxTypes.isInit()
                        && !this.checkboxOptions.every(component => component.isInit())
                        && !this.checkboxPromo.isInit()
                        && !this.checkboxPriceOptions.isInit()
                        && !this.checkboxStar.isInit()
                        && !this.distanceFilters.every(component => component.isInit())
                    ) {
                        utils.triggerEvent('kurortSearchDatepickerReset');
                    } else {
                        this.priceSearch.reset();
                        if (this.roomSearch) {
                            this.roomSearch.reset();
                        }
                        this.checkboxTypes.reset();
                        this.checkboxOptions.forEach(component => component.reset());
                        this.checkboxPromo.reset();
                        this.checkboxPriceOptions.reset();
                        this.checkboxStar.reset();
                        this.distanceFilters.forEach(component => component.reset());

                        const $noFoundFilterContainer = document.querySelector('.js-noFoundFilterContainer');

                        while($noFoundFilterContainer.children.length) {
                            $noFoundFilterContainer.children[0].remove();
                        }

                        obj.formRecalc();
                    }

                    if (typeof onResetCallback === 'function') {
                        onResetCallback();
                    }
                }

                // Изменить условия поиска
                if (targetClosest('.js-changeDataFilter')) {
                    document.querySelectorAll('.js-filterForm .js-dateRangePicker').forEach(($datePicker) => {
                        $datePicker.dispatchEvent(new MouseEvent('click'));
                    });
                }

                // сброс расстояние до моря
                if (targetClosest('.js-resetDistanceFilter[data-name]')) {
                    const $element = event.target.closest('.js-resetDistanceFilter[data-name]');
                    this.distanceFilters.find(component => component.name == $element.dataset.name).reset();
                }

                if (targetClosest('.js-resetFilterItem')) {
                    const $element = event.target.closest('.js-resetFilterItem');

                    let id   = $element.getAttribute('data-id');
                    let type = $element.getAttribute('data-type');

                    if (type === 'price') {
                        // цены

                        // сброс минималки
                        if ($element.classList.contains('js-resetMinPrice')) {
                            obj.priceSearch.resetFrom();
                        }

                        // сброс максималки
                        if ($element.classList.contains('js-resetMaxPrice')) {
                            obj.priceSearch.resetTo();
                        }

                        obj.formRecalc();

                        return;
                    }

                    // if (type === 'review_id') {
                    //     radioReviewOptions.reset();

                    //     obj.formRecalc();

                    //     return;
                    // }

                    // тип жилья, опции объекта и спец предложения
                    const $tag = $element.parentElement;

                    let $input = document.querySelector('input[data-id="' + id + '"][data-type="' + type + '"]');
                    if ($input) {
                        $input.parentElement.querySelector('.js-checkboxItem').click();

                        $element.parentElement.remove();

                        if ($tag.parentElement && $tag.parentElement.children.length === 0) {
                            $tag.parentElement.remove();
                        }
                    }
                }
            });
        }
        triggers.bind(this)();

        /**
         * Новые точки для опций объектов
         */
        this.hotelsOptionsDots = function() {
            const $hotelOptionsList = document.querySelectorAll('.js-hotelOptions');
            if ($hotelOptionsList && $hotelOptionsList.length) {
                $hotelOptionsList.forEach(function ($hotelOptions) {
                    if ($hotelOptions.children.length > 0 && $hotelOptions.children[$hotelOptions.children.length - 1].textContent != '...') {
                        $hotelOptions.insertAdjacentHTML('beforeend', '<div class="Slide-dest__tag">...</div>');
                    }

                    while ($hotelOptions.children.length > 1 && $hotelOptions.scrollHeight > $hotelOptions.offsetHeight) {
                        $hotelOptions.removeChild($hotelOptions.children[$hotelOptions.children.length - 2]);
                    }
                });
            }
        }

        // на случай ресайза
        window.addEventListener('resize', () => {
            utils.throttle(this.hotelsOptionsDots, 100);
            this.switchSlide($periodButton,  $lastButtonSlide);
        });

        /**
         * Ползунок стоимости
         */
        this.priceSearch = new KurortPriceFilter($form.querySelector('.js-price-filter'), {
            on: {
                change: () => {
                    obj.formRecalc();
                },
            },
        });
        this.priceSearch.init();
        utils.subscribeEvent('priceSearchReset', this.priceSearch.reset.bind(this.priceSearch));

        /**
         * Этажность квартир
         */
        if ($form[0].querySelector('.js-floor-filter')) {
            this.roomSearch = new KurortRoomFilter($form.querySelector('.js-floor-filter'), {
                on: {
                    change: () => {
                        obj.formRecalc();
                    },
                },
            });
        }

        /**
         * Чекбоксы типов жилья
         */
        this.checkboxTypes = new KurortCheckboxSearch({
            values: getArraySearchParams('type_list'),
            container: document.querySelector('.js-typeContainer'),
            onChangeCallback: obj.formRecalc,
        });
        this.checkboxTypes.init();

        /**
         * Чекбоксы опций
         */
        this.checkboxOptions = [...document.querySelectorAll('.js-optionContainer')].map($container => {
            const availableValues = [...$container.querySelectorAll('input[type="checkbox"][name]')].map($checkbox => $checkbox.name.match(/^\w+\[(\d+)\]$/)[1]);

            const component = new KurortCheckboxSearch({
                values: getArraySearchParams('option_list').filter(value => availableValues.includes(value)),
                container: $container,
                onChangeCallback: obj.formRecalc,
            });

            component.init();

            component.groupId   = +$container.dataset.groupId;
            component.fieldName = $container.dataset.fieldName;

            component.on('select', function(data) {
                if (data.name !== 'option_list[34]') return;

                let $petsButton = document.querySelector('.js-filterForm .js-petsButton');
                let $petsInput = document.querySelector('.js-filterForm input[name="with_pets"]');

                if (!$petsButton) return;

                if (data.isChecked) {
                    $petsButton.classList.add('is-active');
                } else {
                    $petsButton.classList.remove('is-active');
                }

                $petsInput.value = data.isChecked ? 1 : 0;
            });

            return component;
        });

        /**
         * Чекбоксы промоакций
         */
        this.checkboxPromo = new KurortCheckboxSearch({
            values: getArraySearchParams('promo_list'),
            container: document.querySelector('.js-promoContainer'),
            onChangeCallback: obj.formRecalc,
        });
        this.checkboxPromo.init();

        /**
         * Чекбоксы ценовых опций
         */
        this.checkboxPriceOptions = new KurortCheckboxSearch({
            values: getArraySearchParams('price_option_list'),
            container: document.querySelector('.js-priceOptionContainer'),
            onChangeCallback: obj.formRecalc,
        });
        this.checkboxPriceOptions.init();

        /**
         * Чекбоксы звезд
         */
        this.checkboxStar = new KurortCheckboxSearch({
            values: getArraySearchParams('star_list'),
            container: document.querySelector('.js-starContainer'),
            onChangeCallback: obj.formRecalc,
        });
        this.checkboxStar.init();

        /**
         * Расстояние до берега
         */
        this.distanceFilters = [...document.querySelectorAll('.js-distanceFilter')].map($el => {
            return new KurortDistanceFilter($el, {
                value: url.searchParams.get(`distances[${$el.dataset.name}]`),
                title: $el.dataset.title,
                filterTitle: $el.dataset.filterTitle,
                name: $el.dataset.name,
                on: {
                    change: () => obj.formRecalc(),
                },
            });
        });

        /**
         * Анимация переключения кнопок
         */
        this.switchSlide = function($from, $to) {
            $buttonsSlide.style.width = `${$to.offsetWidth}px`;
            $buttonsSlide.style.height = `${$to.offsetHeight}px`;
            $buttonsSlide.style.transform = `translateX(${$to.offsetLeft - 20}px)`;

            $lastButtonSlide = $to;

            setTimeout(() => {
                $from.classList.remove('is-active');
                $lastButtonSlide.classList.add('is-active');
            }, 50);
        }

        $periodButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            this.switchSlide($dayButton, $periodButton);

            this.checkboxPriceOptions.recalcByType('period');
        }.bind(this));

        $dayButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            this.switchSlide($periodButton, $dayButton);

            this.checkboxPriceOptions.recalcByType('day');
        }.bind(this));

        if ($periodButton.classList.contains('is-active')) {
            this.switchSlide($dayButton, $periodButton);
        } else {
            this.switchSlide($periodButton, $dayButton);
        }

        /**
         * Компонент добавления информационных плашек
         */
        this.kurortInfoPlate = new KurortInfoPlate({
            container: '.js-hotelList',
        });

        this.$fastBooking = document.querySelector('.js-fastBooking');
        this.$fastBookingButton = document.querySelector('.js-fastBookingButton');
        if (this.$fastBooking && this.$fastBookingButton) {
            this.$fastBookingButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                this.$fastBookingButton.classList.toggle('is-active');
                this.$fastBooking.value = this.$fastBooking.value == 1 ? 0 : 1;

                obj.formRecalc();
            });
        }

        this.$isDiscount = document.querySelector('.js-isDiscount');
        this.$isDiscountButton = document.querySelector('.js-isDiscountButton');
        if (this.$isDiscount && this.$isDiscountButton) {
            this.$isDiscountButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                this.$isDiscountButton.classList.toggle('is-active');
                this.$isDiscount.value = this.$isDiscount.value == 1 ? 0 : 1;

                obj.formRecalc();
            });
        }

        utils.subscribeEvent('formRecalc', obj.formRecalc);
        utils.subscribeEvent('mapFetch', obj.formRecalc);

        this.initialized = true;

        this.showResultFilter();

        // инициализация всякой хрени на карточках
        utils.jsDots();
        this.hotelsOptionsDots();
        this.updateDots();
        this.initPhotosSlider();
        this.initBadgesSlider();

        const detectedPage = Pagination.detectPage();
        if (detectedPage) {
            this.setPage(detectedPage);
        }
    }.bind(this);

    /**
     * Пересчет фильтров страницы
     */
    this.formRecalc = function(args = {}) {
        if (!this.initialized) {
            return;
        }

        const show_more = args.show_more || false;
        let hasFormData = false;


        // показать ещё
        if (show_more) {
            this.setPage(this.getPage() + 1);
        }

        // сброс пагинации при манипуляции с фильтрами
        else if (!args.page) {
            this.setPage(1);
        }

        if (isPercentFilterActive()) {
            if (args.data) {
                args.data['is_percent'] = 1;

                if (args.replaceData) {
                    args.data = Object.assign(args.data, args.replaceData);
                }
            } else {
                hasFormData = true;
            }
        }

        args = {
            'data': args.data || this.getFormData(show_more),
            'show_more': show_more,
            'callback': typeof args.callback === 'function' ? args.callback : null,
        }

        if (hasFormData) {
            args.data.push({
                name: 'is_percent',
                value: 1,
            });
        }

        const $hotelBlock = document.querySelector('.js-hotelBlock');
        const $hotelList = document.querySelector('.js-hotelList');
        const $hotelListSkelet = document.querySelector('.js-hotelListSkelet');

        if (this._lastFetch) {
            this._lastFetch.abort();
        }

        // прелоадер для показать еще
        if (args.show_more === true) {
            $hotelBlock.classList.remove('is-loaded');
            $hotelBlock.classList.add('is-loading');
        }

        // прелоадер для всего остального
        if (args.show_more === false) {
            $hotelList.classList.add('is-hidden');
            $hotelListSkelet.classList.remove('is-hidden');
        }

        // левый фильтр
        const $leftFilter = document.querySelector('.js-leftFilterContainer');
        if ($leftFilter) {
            $leftFilter.classList.add('is-loading');
            $leftFilter.classList.add('is-loading');
        }

        // блок "нет результатов"
        if (document.querySelector('.js-containerResultFilter')) {
            document.querySelector('.js-containerResultFilter').classList.remove('is-active');
        }

        if (document.querySelector('.js-headerResultFilter')) {
            document.querySelector('.js-headerResultFilter').classList.remove('is-active');
        }

        if (document.querySelector('.js-noFoundFilterWrapper')) {
            document.querySelector('.js-noFoundFilterWrapper').classList.add('is-hidden');
        }

        utils.triggerEvent('updateMapBefore', args);

        const search = args.data
            .filter(param => param.value != '' && param.value != '0')
            .map(params => `${params.name}=${encodeURIComponent(params.value)}`);

        // боты могут реагировать на изменение адресной строки, поэтому первое событие стоит игнорировать
        if (this.isNotFirstInteraction) {
            window.history.replaceState(null, '', `${window.location.pathname}?${search.join('&')}`);
        }
        this.isNotFirstInteraction = true;

        search.push(`ts=${Date.now()}`);

        this._lastFetch = new AbortController();
        fetch(`${window.location.pathname}?${search.join('&')}`, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
            },
            cache: 'no-cache',
            signal: this._lastFetch.signal,
        })
        .then(response => response.json())
        .then(response => {
            // сбрасываем кеш, чтобы данные были актуальные после запроса, а то кеш сохраняет только первую версию
            window.ajaxGetData = null;

            this.hotelListRecalc({
                args,
                request: response,
            });

            this.recalcFilters(response, args);

            // пересчет карты
            utils.triggerEvent('updateMap', response, args);

            // отмечаем избранное
            utils.checkFavoriteList();

            checkOnMapSubset();

            this.showResultFilter();
        })
        .catch(error => {
            if (error.name === 'AbortError') {
                return;
            }

            const $hotelBlock = document.querySelector('.js-hotelBlock');
            const $hotelListSkelet = document.querySelector('.js-hotelListSkelet');
            const $hotelList = document.querySelector('.js-hotelList');

            $hotelListSkelet.classList.add('is-hidden');
            $hotelList.classList.remove('is-hidden');
            $hotelBlock.classList.remove('is-loading');
            $hotelBlock.classList.add('is-loaded');
            document.querySelectorAll('.js-leftFilterContainer').forEach($element => {
                $element.classList.remove('is-loading');
            });
        });
    }.bind(this);

    this.updateDots = function() {
        document.querySelectorAll('.js-objectProperties').forEach($container => {
            let offsetTop = 0;

            $container.querySelectorAll('.js-property').forEach($item => {
                $item.classList.remove('new-row');

                if (offsetTop == 0) {
                    offsetTop = $item.offsetTop;
                }

                if (offsetTop < $item.offsetTop) {
                    offsetTop = $item.offsetTop;
                    $item.classList.add('new-row');
                }
            });
        });
    }

    this.recalcFilters = function(request, args = {}) {
        // пересчет опций цен
        if (request.diff_days > 0) {
            this.checkboxPriceOptions.recalc(request.data.price_option_list, 'period', request.diff_days);
        } else {
            this.checkboxPriceOptions.recalc(request.data.price_option_list, 'day');
        }

        // ценовые опции
        if (request.diff_days > 0) {
            this.initDatepickerFn();
        } else {
            this.noInitDatepickerFn()
        }

        // для кнопки показать еще не нужно обновлять фильтры
        if (args.show_more !== true && request.data.hotel_count > 0) {
            // пересчет типов жилья
            this.checkboxTypes.recalc(request.data.type_list);

            // пересчет опций жилья
            request.data.option_list.forEach(group => {
                const component = this.checkboxOptions.find(component => component.groupId == group.id);

                if (component) {
                    component.recalc(group.items);
                }
            });

            // опции номеров
            if (request.data.floor_option_list) {
                const component = this.checkboxOptions.find(component => component.fieldName == 'floor_option_list');

                if (component) {
                    component.recalc(request.data.floor_option_list);
                }
            }

            // пересчет спецпредложений
            this.checkboxPromo.recalc(request.data.promo_list);

            // пересчет звёзд
            this.checkboxStar.recalc(request.data.star_list);

            // пересчет лимитов стоимости
            this.priceSearch.setStats(request.data.price_stats);

            // пересчет лимитов стоимости
            this.priceSearch.updatePriceTextPlaceholder(request.data.min_hotel_price, request.data.max_hotel_price);

            // пересчет расстояния до моря
            request.data.distance_list.forEach(group => {
                const component = this.distanceFilters.find(component => component.name == group.name);

                if (component) {
                    group.filter.unshift({title: 'Не выбрано', value: 0});
                    component.recalc(group.filter);
                }
            });
        }

        const $kurortClearFitlers = document.querySelector('.js-kurortClearFilters');

        if (
            this.priceSearch.isInit()
            || (this.roomSearch && this.roomSearch.isInit())
            || this.checkboxTypes.isInit()
            || this.checkboxOptions.some(component => component.isInit())
            || this.checkboxPromo.isInit()
            || this.checkboxPriceOptions.isInit()
            || this.checkboxStar.isInit()
            || this.distanceFilters.some(component => component.isInit())
        ) {
            $kurortClearFitlers.classList.remove('is-hidden');
        } else {
            $kurortClearFitlers.classList.add('is-hidden');
        }

        // после пробрасывания данных надо выбрать таб который был выбран ранее, да бред
        const $priceOptionButtons = document.querySelector('.js-priceOptionButtons');
        const $periodButton       = $priceOptionButtons.querySelector('.js-periodButton');
        const $dayButton          = $priceOptionButtons.querySelector('.js-dayButton');
        if ($dayButton.classList.contains('is-active')) {
            $dayButton.click();
        } else {
            $periodButton.click();
        }
    }.bind(this);

    /**
     *  AJAX/html5 history метод
     *  @param {String} url - меняем адрес страницы
     *  @param {Object} request - данные по объектам
     *  @param {String} action - логика вставки объектов или любая другая
     */
    this.hotelListRecalc = function(args) {
        const request = args.request;
        const data    = request.data;
        args          = args.args;

        const $hotelBlock = document.querySelector('.js-hotelBlock');
        const $filterOptions = document.querySelectorAll('.js-noFoundFilterWrapper');
        const $hotelListSkelet = document.querySelector('.js-hotelListSkelet');
        const $hotelList = document.querySelector('.js-hotelList');
        const $paginator = document.querySelector('.js-paginationBlock');
        let $loadMoreButton = $paginator ? $paginator.querySelector('.js-moreHotels') : [];

        // есть объекты в поиске
        if (data.hotel_count === 0) {
            // прячем скелет
            $hotelListSkelet.classList.add('is-hidden');

            // флаг загрузки
            $hotelBlock.classList.remove('is-loading');
            $hotelBlock.classList.add('is-loaded');

            $filterOptions.forEach($option => {
                $option.classList.remove('is-hidden');
            });

            // левый фильтр
            document.querySelectorAll('.js-leftFilterContainer').forEach($element => {
                $element.classList.remove('is-loading');
            });

            // если показывается плитка, а не карта
            if ($hotelBlock.classList.contains('Object-tile--tile')) {
                $hotelList.style.display = 'flex';
            }

            $hotelList.classList.add('is-hidden');

            this.showContainerResultFilter();

            // прячем счетчик
            document.querySelectorAll('.js-hotelCount').forEach($element => {
                $element.classList.add('is-hidden');
            });

            return false;
        }

        // не опираемся на is-active из SSR/html_static — только на ответ AJAX
        if (data.has_objects === false) {
            this.showContainerResultFilter();
        } else {
            document.querySelector('.js-containerResultFilter')?.classList.remove('is-active');
            document.querySelector('.js-headerResultFilter')?.classList.remove('is-active');
        }

        // получили ответ
        if (request.status === 'ok' && typeof data.hotel_list === 'string' && data.hotel_list.length > 0) {
            // удаляем кнопку показать еще
            $loadMoreButton.forEach($element => $element.remove());

            // заменяем содержимое
            if (args.show_more === false) {
                $hotelList.innerHTML = data.hotel_list;

                // прячем скелет
                $hotelListSkelet.classList.add('is-hidden');

                // флаг загрузки
                $hotelList.classList.remove('is-hidden');
                $hotelBlock.classList.remove('is-loading');
                $hotelBlock.classList.add('is-loaded')
                $filterOptions.forEach($element => $element.classList.remove('is-hidden'));

                // левый фильтр
                document.querySelectorAll('.js-leftFilterContainer').forEach($element => {
                    $element.classList.remove('is-loading');
                });

                // если показывается плитка, а не карта
                if ($hotelBlock.classList.contains('Object-tile--tile')) {
                    $hotelList.style.display = 'flex';
                }

                utils.jsDots();
                this.hotelsOptionsDots();
                this.updateDots();
                this.initPhotosSlider();
                this.initBadgesSlider();

                // обсервер просмотров карточек
                utils.updateHotelViewObserver();
            }

            // добавляем контента
            if (args.show_more === true) {
                // удаляем кнопку показать еще
                document.querySelector('.js-moreHotels').remove();
                document.querySelector('nav.js-pagination').remove();

                $hotelList.insertAdjacentHTML('beforeend', data.hotel_list);

                // флаг загрузки
                $hotelList.classList.remove('is-hidden');
                $hotelBlock.classList.remove('is-loading');
                $hotelBlock.classList.add('is-loaded');

                $filterOptions.forEach($element => $element.classList.remove('is-hidden'));

                // левый фильтр
                document.querySelectorAll('.js-leftFilterContainer').forEach($element => {
                    $element.classList.remove('is-loading');
                });

                this.hotelsOptionsDots();
                this.updateDots();
                this.initPhotosSlider();
                this.initBadgesSlider();

                // обсервер просмотров карточек
                utils.updateHotelViewObserver();

                if (args.callback !== null) {
                    args.callback();
                }
            }

            // разделитель для другие объекты
            const $hotel = document.querySelector('#hotel-' + request.separator_hotel_id);
            if (request.separator_hotel_id > 0 && !$hotelList.closest('.js-objectSeparator') && $hotel) {
                $hotel.insertAdjacentHTML('beforebegin',
                    `<div class="Kurort-selection__separator js-objectSeparator">
                        <div class="Kurort-selection__separator-wrapper">
                            <div class="Kurort-selection__separator-logo"></div>
                            <div class="Kurort-selection__separator-title">Объекты рядом</div>
                        </div>
                    </div>`
                );
            }

            // создаём плашку
            const $hotelItemList = $hotelList.querySelectorAll('.js-hotelItem');

            if ($hotelItemList?.length > 0) {
                const $plateSupport = this.kurortInfoPlate.create('support');

                if ($plateSupport) {
                    $hotelList.insertBefore($plateSupport, $hotelItemList[2]);
                }
            }

            if ($hotelItemList?.length > 15) {
                // Временно скрыто
                // если дат нет - не показываем блок
                // let hasDates = false;
                // let count    = 0;
                //
                // hasDates = (args.data || []).some(function(item) {
                //     return ~['date_start', 'date_finish'].indexOf(item.name) && item.value;
                // });
                //
                // if (!hasDates) {
                //     const $plateDatepicker = this.kurortInfoPlate.create('datepicker');
                //     if ($plateDatepicker) {
                //         $hotelList.insertBefore($plateDatepicker, $hotelItemList[6]);
                //     }
                // }

                // временно скрыто
                // const $plateVKBanner = this.kurortInfoPlate.create('vkDefault');

                // if ($plateVKBanner) {
                //     $hotelList.insertBefore($plateVKBanner, $hotelItemList[2]);
                // }

                const $plateMap = this.kurortInfoPlate.create('map');

                if ($plateMap) {
                    $hotelList.insertBefore($plateMap, $hotelItemList[2]);
                }

                // Временно скрыто
                // const $plateDiscount = this.kurortInfoPlate.create('discount');
                // if ($plateDiscount) {
                //     $hotelList.insertBefore($plateDiscount, $hotelItemList[12]);
                // }
            }

            // счетчик
            document.querySelectorAll('.js-hotelCount').forEach($element => {
                $element.classList.remove('is-hidden');
                $element.textContent = `${utils.declension(data.hotel_count, 'Найден', 'Найдено', 'Найдено')} ${utils.formatMoney(data.hotel_count, 2, '.', ' ')} ${data.hotel_count_variant_title} из ${utils.formatMoney(data.all_hotel_count, 2, '.', ' ')}`
            });
        }

        // просмотр страницы
        if (args.url) {
            checkGA(() => {
                ga('set', 'page', args.url);
                ga('send', 'pageview');
                collectGoogleEvent(metrikaCollector, 'Kurort', 'pageview', {page: args.url});
            });

            if (typeof yaCounter46243086 !== "undefined") {
                yaCounter46243086.hit(args.url);
                collectYandexReachGoal(metrikaCollector, 'pageview', {data: {hit: args.url}});
            }

            // меняем адрес страницы
            if (request.header) {
                window.history.pushState(request, request.header, args.url);
            } else {
                window.history.pushState(request, 'ПриветТур', args.url);
            }
        }

        if (document.querySelector('nav.js-pagination')) {
            new Pagination(document.querySelector('nav.js-pagination'), {
                on: {
                    page: (number, href) => {
                        // сначала скролл, потом обновление рендера
                        const $hideSeachBlock = document.querySelector('.js-hideSeachBlock');
                        if ($hideSeachBlock) {
                            $hideSeachBlock.scrollIntoView({
                                behavior: 'smooth',
                            });
                        }

                        this.setPage(number);
                        this.formRecalc({
                            page: true,
                        });
                    },
                },
            });
        }
    }

    this.setOnResetCallback = function(callback) {
        onResetCallback = callback;
    }

    this.initPhotosSlider = function () {
        const $photosContainers = document.querySelectorAll('.js-objectPhotosSlider:not(.swiper-initialized)');

        $photosContainers.forEach(($container) => {
            new Swiper($container, {
                slidesPerView: 1,
                loop: true,
                lazyPreloadPrevNext: 1,
                navigation: {
                    nextEl: $container.querySelector('.js-arrowNext'),
                    prevEl: $container.querySelector('.js-arrowPrev'),
                },
                pagination: {
                    el: $container.querySelector('.pagination'),
                    dynamicBullets: true,
                    dynamicMainBullets: 4,
                    clickable: true,
                },
            });
        });
    };

    this.initBadgesSlider = function() {
        const $badges = document.querySelectorAll('.js-objectBadges:not(.swiper-initialized)');

        $badges.forEach(($container) => {
            new Swiper($container, {
                slidesPerView: 'auto',
                spaceBetween: 4,
            });
        });
    }

    // копируем фильтры в $container, наприме для модалки карты
    this.renderCustomFilters = function($container) {
        // удаляем старые фильтры
        $container.querySelectorAll('.js-mapFilterBlockWrapper').forEach($item => $item.remove());

        const $leftFilter = document.querySelector('.js-leftKurortFilter');

        // добавляем фильтр
        $container.appendChild($leftFilter);

        $leftFilter.querySelectorAll('.js-mapFilterBlock').forEach($item => $item.classList.add('Map__filter-block'));
    }

    // копируем фильтры в список объектов
    this.renderDefaultFilters = function() {
        const $leftFilter = document.querySelector('.js-leftKurortFilter');

        document.querySelector('.js-leftFilterContainer').appendChild($leftFilter);

        $leftFilter.querySelectorAll('.js-mapFilterBlock').forEach($item => $item.classList.remove('Map__filter-block'));
    }.bind(this);

    this.getPage = function () {
        const $form = document.querySelector('.js-leftKurortFilter');
        return Number($form.elements['page'].value);
    };

    this.setPage = function (number) {
        const $form = document.querySelector('.js-leftKurortFilter');
        $form.elements['page'].value = number;
    };

    this.init();
}

// возвращаем класс
if (typeof window.kurortFilter === 'undefined') {
    window.kurortFilter = new KurortFilter();
}

export default window.kurortFilter;
